"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _svgIcons = require("front-onceforall-ui-kit/svg-icons.js");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["size", "icon", "color", "className"],
    _excluded2 = ["tooltip"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var cssIcons = ['loader'];

var buildCssIcon = function buildCssIcon(_ref, rest, ref) {
  var iconClassName = _ref.iconClassName,
      style = _ref.style;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    className: iconClassName,
    style: style
  }));
};

var buildSvgPathIcon = function buildSvgPathIcon(_ref2, rest, ref) {
  var iconClassName = _ref2.iconClassName,
      style = _ref2.style,
      icon = _ref2.icon;
  var svgIcon = (0, _svgIcons.getSvgIcon)(icon);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    className: iconClassName,
    style: style,
    viewBox: svgIcon.viewBox,
    children: svgIcon.path
  }));
};

var IconComponent = /*#__PURE__*/_react.default.forwardRef( // eslint-disable-next-line prefer-arrow-callback
function IconComponent(_ref3, ref) {
  var size = _ref3.size,
      icon = _ref3.icon,
      color = _ref3.color,
      className = _ref3.className,
      rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  var style = size ? {
    minHeight: size,
    maxHeight: size,
    minWidth: size,
    maxWidth: size
  } : {};
  var iconClassName = "icon icon-".concat(icon, " ").concat(color);

  if (className) {
    iconClassName += " ".concat(className);
  }

  return cssIcons.includes(icon) ? buildCssIcon({
    iconClassName: iconClassName,
    style: style
  }, rest, ref) : buildSvgPathIcon({
    iconClassName: iconClassName,
    style: style,
    icon: icon
  }, rest, ref);
});

IconComponent.defaultProps = {
  color: '',
  className: ''
};
IconComponent.propTypes = {
  icon: _propTypes.default.string.isRequired,
  size: _propTypes.default.number,
  color: _propTypes.default.string,
  className: _propTypes.default.string
};

var Icon = function Icon(_ref4) {
  var tooltip = _ref4.tooltip,
      rest = (0, _objectWithoutProperties2.default)(_ref4, _excluded2);
  return tooltip ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Tooltip, {
    title: tooltip,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(IconComponent, _objectSpread({}, rest))
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(IconComponent, _objectSpread({}, rest));
};

Icon.defaultProps = {
  color: ''
};
Icon.propTypes = {
  tooltip: _propTypes.default.string
};
var _default = Icon;
exports.default = _default;
//# sourceMappingURL=Icon.js.map